var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Directions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2025 5.38249C15.7925 4.97244 15.1276 4.97244 14.7176 5.38249C14.3075 5.79254 14.3075 6.45736 14.7176 6.86741L21.09 13.2398H5.53975C4.95985 13.2398 4.48975 13.7099 4.48975 14.2898C4.48975 14.8697 4.95985 15.3398 5.53975 15.3398H21.0912L14.7173 21.7179C14.3074 22.1281 14.3077 22.7929 14.7178 23.2028C15.128 23.6127 15.7929 23.6125 16.2028 23.2023L24.3676 15.032C24.3714 15.0282 24.3752 15.0244 24.3789 15.0206C24.6818 14.7083 24.7522 14.2543 24.5903 13.876C24.5444 13.7689 24.4799 13.6679 24.3967 13.5779C24.4771 13.6649 24.5429 13.7656 24.5903 13.876",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2025 5.38249L24.364 13.544L16.2025 5.38249Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.32f0eedd00b3e37951f3262548e16e9f.svg";
export { ForwardRef as ReactComponent };